import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { customQueryClient } from '../../config/query-client'
import {
  bulkOperationsMutationKeys,
  bulkOperationsQueryKeys
} from '../constants'

export const useUpdateBulkPinsMutation = (options) => {
  const handleMutation = async ({ source, updates }) => {
    const config = {
      method: 'post',
      data: {
        source,
        updates
      }
    }

    const { data } = await api('/api/v2/bulk/pins', config)
    return data
  }

  const invalidTrackOperationQuery = (mutationParams) => {
    const { source } = mutationParams
    const { projectId } = source

    customQueryClient.invalidateQueries({
      queryKey: [bulkOperationsQueryKeys.BULK_TRACK_OPERATIONS_LIST, projectId]
    })
  }

  const mergedOptions = { ...options }
  const customOnSuccess = options?.onSuccess

  delete mergedOptions.onSuccess

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: bulkOperationsMutationKeys.UPDATE_BULK_PINS,
    retry: 0,
    onSuccess: (data, mutationParams, context) => {
      invalidTrackOperationQuery(mutationParams)

      customOnSuccess?.(data, mutationParams, context)
    },
    ...mergedOptions
  })
}
